"use strict";

exports.__esModule = true;
exports.StyledModalHeader = exports.StyledModalFooter = exports.StyledModalCloseButton = exports.StyledModalBody = exports.StyledModal = exports.ModalBackground = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledReactModal = _interopRequireWildcard(require("styled-react-modal"));

var _breakpoints = require("../../helpers/breakpoints");

var _P = _interopRequireDefault(require("../typography/text/P"));

var _H = _interopRequireDefault(require("../typography/headings/H1"));

var _H2 = _interopRequireDefault(require("../typography/headings/H2"));

var _H3 = _interopRequireDefault(require("../typography/headings/H3"));

var _H4 = _interopRequireDefault(require("../typography/headings/H4"));

var _H5 = _interopRequireDefault(require("../typography/headings/H5"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const showModal = (0, _styledComponents.keyframes)`
    0% {
        transform: translate(0, -50px);
        opacity: 0;
        animation-timing-function: ease-out;
    }
    50% {
        transform: translate(0, -50px);
        opacity: 0;
        animation-timing-function: ease-out;
    }
    100% {
        transform: translate(0, 0);
        opacity: 1;
    }
`;
const hideModal = (0, _styledComponents.keyframes)`
    0% {
        transform: translate(0, 0);
        opacity: 1;
        animation-timing-function: ease-in;
    }
    33% {
        transform: translate(0, -50px);
        opacity: 0;
    }
    100% {
        transform: translate(0, -50px);
        opacity: 0;
    }
`;
const StyledModal = _styledReactModal.default.styled`
    position: relative;
    width: 80vw;
    max-width: 80%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${({
  theme
}) => theme.colors.modals.background};
    border-radius: ${({
  theme
}) => theme.borderRadius.medium};
    color: ${({
  theme
}) => theme.colors.modals.text};
    pointer-events: auto;
    animation: ${showModal} 600ms;

    ${_breakpoints.breakpointUp.md`
        max-width: 500px;

        ${props => props.large && (0, _styledComponents.css)`
            max-width: 80%;
        `}
    `}

    ${props => props.closing && (0, _styledComponents.css)`
        animation: ${hideModal} 750ms;
    `}

    ${_P.default}, ${_H.default}, ${_H2.default}, ${_H3.default}, ${_H4.default}, ${_H5.default} {
        color: ${({
  theme
}) => theme.colors.modals.text};
    }

`;
exports.StyledModal = StyledModal;
const StyledModalHeader = _styledComponents.default.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: calc(100% - (${({
  theme
}) => theme.space[5]} * 2));
    margin: 0 ${({
  theme
}) => theme.space[5]};
    padding: ${({
  theme
}) => theme.space[5]} 0;
    border-top-left-radius: ${({
  theme
}) => theme.borderRadius.medium};
    border-top-right-radius: ${({
  theme
}) => theme.borderRadius.medium};
    border-bottom: 1px solid ${({
  theme
}) => theme.colors.modals.separators};
`;
exports.StyledModalHeader = StyledModalHeader;
const StyledModalBody = _styledComponents.default.div`
    position: relative;
    flex: 1 1 auto;
    width: calc(100% - (${({
  theme
}) => theme.space[5]} * 2));
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    margin: ${({
  theme
}) => theme.space[5]} 0;

    a {
        color: ${({
  theme
}) => theme.colors.modals.link.text};

        &:active {
            color: ${({
  theme
}) => theme.colors.modals.link.text};
        }

        &:hover,
        &:focus {
            color: ${({
  theme
}) => theme.colors.modals.link.hover.text};
        }
    }
`;
exports.StyledModalBody = StyledModalBody;
const StyledModalFooter = _styledComponents.default.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - (${({
  theme
}) => theme.space[5]} * 2));
    margin: 0 ${({
  theme
}) => theme.space[5]};
    padding: ${({
  theme
}) => theme.space[5]} 0;
    border-bottom-left-radius: ${({
  theme
}) => theme.borderRadius.medium};
    border-bottom-right-radius: ${({
  theme
}) => theme.borderRadius.medium};
    border-top: 1px solid ${({
  theme
}) => theme.colors.modals.separators};
`;
exports.StyledModalFooter = StyledModalFooter;
const StyledModalCloseButton = _styledComponents.default.button`
    height: 18px;
    width: 18px;
    position: absolute;
    top: ${({
  theme
}) => theme.space[5]};
    right: ${({
  theme
}) => theme.space[5]};
    padding: 0;
    background-color: transparent;
    border: none;
    outline: none;

    @media (hover: none) and (pointer: coarse) {
        height: 50px;
        width: 50px;
        top: 0;
        right: 4px;
        padding: ${({
  theme
}) => theme.space[5]};
    }

    svg {
        cursor: pointer;
    }

    &:hover svg {
        opacity: 0.8;
    }

    span {
        display: none;
    }
`;
exports.StyledModalCloseButton = StyledModalCloseButton;
const ModalBackground = (0, _styledComponents.default)(_styledReactModal.BaseModalBackground)`
    background-color: ${({
  theme,
  backgroundVisible
}) => backgroundVisible ? theme.colors.modals.overlay : 'rgba(0,0,0,0)'};
    transition: background-color linear 250ms;
`;
exports.ModalBackground = ModalBackground;